export default "__VITE_ASSET__QBpwJNTO__"